import { z } from "zod/v4";

import { createEndpointBase } from "./core";

export const PLATFORMS_BASE_PATH = "platforms";
const platforms = createEndpointBase(PLATFORMS_BASE_PATH);

export const platformsEndpoints = {
  platformsAdministration: platforms({
    method: "GET",
    path: "administration",
    request: z.any(),
    response: z.any(),
    description: "Retrieves metadata for administration platforms.",
  }),
  platformsRunner: platforms({
    method: "GET",
    path: "runner",
    request: z.any(),
    response: z.any(),
    description: "Retrieves runner platforms (Not supported).",
  }),
  platformsMeta: platforms({
    method: "GET",
    path: "meta/:platformType",
    request: z.any(),
    response: z.array(
      z.object({
        id: z.string(),
        platformType: z.string(),
        conditionFile: z.string().optional(),
        files: z.array(z.string()),
      }),
    ),
    description: "Retrieves metadata for specific platform types.",
  }),
  platformsDownloadExtension: platforms({
    method: "GET",
    path: "extension/download",
    request: z.any(),
    response: z.any(),
    description: "Downloads the latest runner extension ZIP file.",
  }),
  platformsExtensionVersion: platforms({
    method: "GET",
    path: "extension/version",
    request: z.any(),
    response: z.object({ version: z.string() }),
    description: "Retrieves the latest version of the runner extension.",
  }),
  platformsDownloadScript: platforms({
    method: "GET",
    path: "downloadScript/:id/:platformType/:filename",
    request: z.any(),
    response: z.any(),
    description: "Downloads a specific platform script file.",
  }),
} as const;
